import React from "react";
import ReactDOM from "react-dom/client";
import "./index.sass";
import App from "./pages/App";
import { ConfigProvider } from "antd";
import { BrowserRouter, Routes } from "react-router";
import AppRoutes from "./routes";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#2BC6E8",
          colorTextBase: "#fff"
        },
      }}
    >
      <AppRoutes/>
    </ConfigProvider>
  </React.StrictMode>
  </BrowserRouter>
);
